let $ = require( "jquery" );

$(function() {

    let fullScreenVideos = $('.full-screen-video-container');
    let videosWithOverlays = $('.video-with-text.is-style-overlay');

	let isElementInViewport = function (el) {
		var rect = el.getBoundingClientRect();
		return (
			// rect.top >= 0 &&
			// rect.left >= 0 &&
			rect.bottom >= 0 && // if bottom < 0, element has scrolled out of view
			// rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
	
			rect.top <= (window.innerHeight || document.documentElement.clientHeight)
		);
	};

    if(fullScreenVideos.length) {
        fullScreenVideos.each(function () {

            let video = $(this).find('iframe')[0],
                playButton = $(this).find('.video-play-button');



        });
    }

	videosWithOverlays.each(function(){
		if ($(window).outerWidth() < 992 ) return;
		let $this = $(this);
		let startingPosition = 25;
		$(window).on('scroll', function(){
			let offset = $this.offset().top;
			let amountInView = $(window).scrollTop() + window.innerHeight - offset;
			if (isElementInViewport($this[0])) { 
				$this.find('video').css('top', startingPosition + amountInView/25 + '%');
			}
		});
	});

});
